"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.KShape = void 0;
var figureBase_1 = require("../../../core/base/figureBase");
var line3_1 = require("../../../core/base/line3");
var three_1 = require("three");
var KShape = /** @class */ (function (_super) {
    __extends(KShape, _super);
    function KShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KShape.prototype.calculateConnectionIndexes = function () {
        return [0, 1, 2];
    };
    KShape.prototype.calculateLines = function () {
        var coords = this.config.options;
        var aPoint = new three_1.Vector3(coords.width / 2, 0);
        var bPoint = new three_1.Vector3(-coords.width / 2, 0);
        var cPoint = new three_1.Vector3(-coords.width / 2, coords.height);
        var dPoint = new three_1.Vector3(-coords.width / 2 + coords.topWidth, coords.height);
        var ePoint = new three_1.Vector3(0, coords.height / 2);
        return [new line3_1.Line3(line3_1.LineType.Straight, [aPoint, bPoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [bPoint, cPoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [cPoint, dPoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [dPoint, ePoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [ePoint, aPoint]),
        ];
    };
    KShape.prototype.getConfigProperties = function () {
        return {
            width: 1,
            height: 1,
            topWidth: 0.7
        };
    };
    return KShape;
}(figureBase_1.FigureBase));
exports.KShape = KShape;
